import moment from 'moment';
export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];
export const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const groupByDate = (data: any[], attribute: string): any[] => {
  const groups = data.reduce((groups, item) => {
    const fullDate = new Date(item[attribute]);
    const date = moment(new Date(fullDate)).format('YYYY-MM-DD');
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(item);
    return groups;
  }, {});

  const groupArrays = Object.keys(groups).map((date) => {
    const today = new Date();
    const keyDate = new Date(date);
    const formattedDate =
      today.getFullYear() === keyDate.getFullYear() &&
      today.getMonth() === keyDate.getMonth() &&
      today.getDate() === keyDate.getDate()
        ? 'Today'
        : today.getFullYear() === keyDate.getFullYear() &&
          today.getMonth() === keyDate.getMonth() &&
          today.getDate() - 1 === keyDate.getDate()
        ? 'Yesterday'
        : days[keyDate.getDay()] +
          ', ' +
          months[keyDate.getMonth()] +
          ' ' +
          keyDate.getDate() +
          (keyDate.getDate() % 10 == 1 && keyDate.getDate() != 11
            ? 'st'
            : keyDate.getDate() % 10 == 2 && keyDate.getDate() != 12
            ? 'nd'
            : keyDate.getDate() % 10 == 3 && keyDate.getDate() != 13
            ? 'rd'
            : 'th') +
          (keyDate.getFullYear() !== today.getFullYear() ? ', ' + keyDate.getFullYear() : '');
    return {
      date,
      formattedDate,
      items: groups[date]
    };
  });

  return groupArrays;
};

export const dateLabel = (item: { timestamp: number }): any => {
  const today = new Date();
  const keyDate = new Date(1000 * item.timestamp);
  const formattedDate =
    today.getFullYear() === keyDate.getFullYear() &&
    today.getMonth() === keyDate.getMonth() &&
    today.getDate() === keyDate.getDate()
      ? 'Today'
      : today.getFullYear() === keyDate.getFullYear() &&
        today.getMonth() === keyDate.getMonth() &&
        today.getDate() - 1 === keyDate.getDate()
      ? 'Yesterday'
      : days[keyDate.getDay()] +
        ', ' +
        months[keyDate.getMonth()] +
        ' ' +
        keyDate.getDate() +
        (keyDate.getDate() % 10 == 1 && keyDate.getDate() != 11
          ? 'st'
          : keyDate.getDate() % 10 == 2 && keyDate.getDate() != 12
          ? 'nd'
          : keyDate.getDate() % 10 == 3 && keyDate.getDate() != 13
          ? 'rd'
          : 'th') +
        (keyDate.getFullYear() !== today.getFullYear() ? ', ' + keyDate.getFullYear() : '');
  return formattedDate;
};
